import { ModalBtnProps, ModalProps, Modal as _Modal } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { History } from 'history';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { AutosaveStore } from 'stores/AutosaveStore';
import styled from 'styled-components';
import { brand } from 'styles/Colors';

type ModalBtnPropsWithTest = ModalBtnProps & { 'data-test': string };

const Modal = _Modal as unknown as FC<ModalProps & { confirmBtn: ModalBtnPropsWithTest; cancelBtn: ModalBtnPropsWithTest }>;

interface IProps {
  savedSessionId: string;
  sessionId: string;
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  history: History;
}

const ModalBody = styled.div`
  padding: 25px;

  div {
    margin-bottom: 5px;
  }
`;

const SavedSessionModal: React.FC<IProps> = observer((props) => {
  const { savedSessionId, sessionId, isModalVisible, setIsModalVisible, history } = props;
  const autosaveStore = useInjection<AutosaveStore>(ServiceTypes.AutosaveStore);

  const closeHandler = () => {
    setIsModalVisible(false);
  };

  const discardChanges = () => {
    autosaveStore.clear();
    history.push(`/edit/sessionId/${sessionId}`);
  };

  const backToPreviousSession = () => {
    history.push(`/edit/sessionId/${savedSessionId}`);
  };

  return (
    <Modal
      onClose={closeHandler}
      open={isModalVisible}
      title='Saved session changes'
      confirmBtn={{
        label: 'Discard changes',
        onClick: discardChanges,
        'data-test': 'discard-changes-btn',
      }}
      cancelBtn={{
        label: 'Back to saved session',
        onClick: backToPreviousSession,
        style: { backgroundColor: brand, color: '#fff' },
        'data-test': 'back-to-saved-btn',
      }}
      titleCenter
    >
      <ModalBody>
        <div>There are saved changes for session</div>
        <div>{savedSessionId}</div>
        <div>
          Press <b>Discard changes</b> button if you want start cleaning new session
        </div>
        <div>
          Press <b>Back to saved session</b> if you want continue cleaning previous saved session
        </div>
      </ModalBody>
    </Modal>
  );
});

export default SavedSessionModal;
